<template lang="html">
  <section>
    <div v-if="this.$store.state.itensSla.controleExibicaoImpressao">
      <b-table striped hover :items="evidenciasPorItem"> </b-table>
    </div>
  </section>
</template>

<script>
export default {
  props: ['evidencia'],
  data () {
    return {
      evidenciasPorItem: []
    }
  },
  mounted () {
    this.preparaEvidencias()
  },
  watch: {
    evidencia: function () {
      this.preparaEvidencias()
    }
  },
  methods: {
    preparaEvidencias: function () {
      let evidencia = this.evidencia
      this.evidenciasPorItem = []
      for (let i in evidencia) {
        if (evidencia[i].evidencias) {
          evidencia[i].evidencias.map(itemEvidencia => {
            if (itemEvidencia.existe_evidencia === 1) {
              this.evidenciasPorItem.push({
                mes_referencia: itemEvidencia.mes_referencia,
                nao_conformidade_apurada: itemEvidencia.nao_conformidade_apurada,
                item_sla_id: itemEvidencia.item_sla_id,
                unidade_medicao: itemEvidencia.unidade_medicao,
                quandidade_apurada: itemEvidencia.quantidade_apurada,
                'observação': itemEvidencia.observacoes
              })
            }
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// EvidenciaImpressao.vue?0d830dbc